import errorManager from '@/rollbar.js';

const showHideAllergie = (target) => {
  let tab = document.querySelector(target.dataset.target);
  if (target.value == 'false') {
    tab.classList.remove('hide');
  } else {
    tab.classList.add('hide');
  }
};

const setListener = (selector) => {
  const elements = document.querySelectorAll(selector);

  for (var i = 0; i < elements.length; i++) {
    elements[i].addEventListener('change', function () {
      showHideAllergie(this);
    });
  }
  // selector.on('change', (e) => {
  //   showHideAllergie($(e.currentTarget))
  // });
};

const init = (selector) => {
  try {
    setListener(selector);
  } catch (e) {
    errorManager(e);
  }
};

window.allergieNonRiferite = {
  init: init,
};
